export default "__VITE_ASSET__d8fff36f__"